import {
  INSERT_ITEM,
  DELETE_ITEM,
  PBNS_SET,
  PBN_SET,
  FILTERS_SET,
  LANGS_SET,
  ORDER_SET,
  REPORT_SET,
  LINK_ORDER_SET,
  USER_LIST_SET,
  USER_ROLE_LIST_SET,
  REGISTRAR_LIST_SET,
  LINK_ORDERS_SET,
  BUILD_REPORT_SET,
  ORDERS_SET,
  VIEW_FILTERS_SET,
  HOSTS_SET,
  MAINTENANCE_ORDER_SET,
  MAINTENANCE_ORDERS_SET, TASKS_SET, TASK_SET, TEMPLATE_SET, TEMPLATES_SET,
  FILTERS_UPDATE, PPC_DATA_SET, BOOKMARKS_SET,
  APPLIED_FILTER_SET, DATA_SET, PROJECT_TASKS_SET, PROJECTS_SET,
  AFFILIATE_COMPANIES_SET, AFFILIATE_COMPANY_SET,
  BRANDS_SET, BRAND_SET,
  TOPLISTS_SET, TOPLIST_SET
} from './mutation-types.js'

export default {
  isAuthenticated (state, data) {
    state.isAuthenticated = data
  },
  openPlayers (state, data) {
    state.saved.players.push(data)
  },
  addViewData (state, data) {
    state.viewData = data
  },
  [INSERT_ITEM] (state, { index, item }) {
    state.saved.players.splice(index, 0, item)
  },
  [DELETE_ITEM] (state, index) {
    state.saved.players.splice(index, 1)
  },
  removeFromView (state, data) {
    state.saved[data.type].splice(data.key, 1)
  },
  [PBNS_SET] (state, data) {
    state.pbns = data
  },
  [PBN_SET] (state, data) {
    state.pbn = data
  },
  [APPLIED_FILTER_SET] (state, data) {
    state.appliedFilters = data
  },
  [FILTERS_SET] (state, data) {
    state.pbnFilters = data
  },
  [LANGS_SET] (state, data) {
    state.languages = data
  },
  [ORDER_SET] (state, data) {
    state.order = data
  },
  [ORDERS_SET] (state, data) {
    state.orders = data
  },
  [REPORT_SET] (state, data) {
    state.report = data
  },
  [LINK_ORDERS_SET] (state, data) {
    state.linkOrders = data
  },
  [LINK_ORDER_SET] (state, data) {
    state.linkOrder = data
  },
  [BUILD_REPORT_SET] (state, data) {
    state.buildReport = data
  },
  [USER_LIST_SET] (state, data) {
    state.userList = data.map(d => ({show: true, ...d})) // Attach show param
  },
  [REGISTRAR_LIST_SET] (state, data) {
    state.registrarList = data.map(r => ({show: true, ...r})) // Attach show param
  },
  [HOSTS_SET] (state, data) {
    state.hosts = data
  },
  [VIEW_FILTERS_SET] (state, data) {
    state.viewFilters = data
  },
  [MAINTENANCE_ORDERS_SET] (state, data) {
    state.maintenanceOrders = data
  },
  [MAINTENANCE_ORDER_SET] (state, data) {
    state.maintenanceOrder = data
  },
  [TASKS_SET] (state, data) {
    state.tasks = data
  },
  [TASK_SET] (state, data) {
    state.task = data
  },
  [TEMPLATE_SET] (state, data) {
    state.pbnTemplate = data
  },
  [TEMPLATES_SET] (state, data) {
    state.pbnTemplates = data
  },
  setPasswordVisibility (state, data) {
    state.passwordVisibility = data
  },
  [USER_ROLE_LIST_SET] (state, data) {
    state.userRoleList = data.map(r => ({show: true, ...r})) // Attach show param
  },
  [FILTERS_UPDATE] (state, prop, val) {
    state.pbnFilters[prop] = val
  },
  [PPC_DATA_SET] (state, data) {
    state.ppcData = data
  },
  [BOOKMARKS_SET] (state, data) {
    state.userBookmarks = data
  },
  [DATA_SET] (state, data) {
    state.dataStructures[data.name] = data
  },
  [PROJECT_TASKS_SET] (state, data) {
    state.projectTasks = data
  },
  [PROJECTS_SET] (state, data) {
    state.projects = data
  },
  setXeroAccounts (state, data) {
    state.xeroAccounts = data
  },
  setXeroItems (state, data) {
    state.xeroItems = data
  },
  setXeroContacts (state, data) {
    state.xeroContacts = data
  },
  setXeroCategories (state, data) {
    state.xeroCategories = data
  },
  setPbnTypes (state, data) {
    state.pbnTypes = data
  },
  [AFFILIATE_COMPANIES_SET] (state, data) {
    state.affiliateCompanies = data
  },
  [AFFILIATE_COMPANY_SET] (state, data) {
    state.affiliateCompany = data
  },
  [BRANDS_SET] (state, data) {
    state.brands = data.map(r => ({show: true, ...r})) // Attach show param
  },
  [BRAND_SET] (state, data) {
    state.brand = data
  },
  [TOPLISTS_SET] (state, data) {
    state.toplists = data
  },
  [TOPLIST_SET] (state, data) {
    state.toplist = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js